import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loadCashShiftActivities, resetCashShiftActivities } from '../actions';
import CashMovementsTable from '../Tables/CashMovementsTable';
import CashShiftDrawer from '../Tables/CashShiftDrawer';

const Cash = () => {
  const [selectedShiftId, setSelectedShiftId] = useState(null);
  const dispatch = useDispatch();

  const openDrawer = shiftId => {
    setSelectedShiftId(shiftId);
    dispatch(loadCashShiftActivities(shiftId));
  };

  const closeDrawer = () => {
    setSelectedShiftId(null);
    dispatch(resetCashShiftActivities());
  };

  return (
    <>
      <CashMovementsTable onShiftClick={openDrawer} />
      <CashShiftDrawer
        isOpen={selectedShiftId !== null}
        shiftId={selectedShiftId}
        onClose={closeDrawer}
      />
    </>
  );
};

export default Cash;
